var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdventures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.121 19.353l1.562 12.82-4.531 2.476v.926l5.84-.926 6.317.926v-.926l-5.139-2.476 1.567-12.82 12.443 4.371v-3l-12.443-8.648S22.23 3.99 19.992 4.03s-2.87 8.046-2.87 8.046L4.798 20.724v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.007 4.033h-.016c-2.239.04-2.87 8.046-2.87 8.046L4.797 20.727v2.997l12.324-4.37 1.561 12.82-4.531 2.476v.925l5.84-.925 6.317.925v-.925l-5.14-2.477 1.568-12.82 12.443 4.371v-2.997l-12.443-8.648s-.505-8.046-2.729-8.046m0-2.5c.645 0 1.602.182 2.497 1.051.435.422.802.955 1.124 1.629.413.865.75 1.961 1.029 3.35.232 1.157.38 2.303.466 3.13l11.483 7.981a2.5 2.5 0 011.073 2.053v2.997a2.5 2.5 0 01-3.328 2.359l-9.51-3.34-.973 7.956 3.525 1.698a2.5 2.5 0 011.415 2.253v.925a2.5 2.5 0 01-2.863 2.474l-5.94-.87-5.463.865a2.5 2.5 0 01-2.891-2.469v-.925a2.5 2.5 0 011.301-2.194l3.044-1.663-.98-8.04-9.383 3.327a2.5 2.5 0 01-3.336-2.356v-2.997A2.5 2.5 0 013.36 18.68l11.392-7.993c.1-.826.266-1.982.52-3.149.302-1.383.657-2.476 1.084-3.34.33-.665.7-1.192 1.134-1.61.886-.851 1.824-1.044 2.455-1.055h.061z",
    fill: "#24a81b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z",
    fill: "none"
  })));
}
export default SvgAdventures;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Adventures.svg
// module id = 717
// module chunks = 13